export const helpRoute = () => '/help'
